export default __webpack_public_path__ + "static/media/Tata AIA Life Logo.cc88b01b.png";